import { Component, Input, OnInit, Output } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { EventEmitter } from '@angular/core';
import { LottieService } from 'src/app/service/animations/lottie.service';

@Component({
  selector: 'app-currency-counter',
  templateUrl: './currency-counter.component.html',
  styleUrls: ['./currency-counter.component.scss'],
})
export class CurrencyCounterComponent  implements OnInit {

  coinSpinOptions: AnimationOptions | null = null;

  @Input() coins = 0;
  @Input() currencyName = "";
  @Input() coinCustomImg = "";
  @Output() coinClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private lottieService: LottieService,
  ) { }

  ngOnInit() {
    this.coinSpinOptions = this.lottieService._coinSpinOptions;
  }

  onCoinClicked() {
    this.coinClicked.emit();
  }

}
